import { createFileRoute, redirect } from '@tanstack/react-router';
import { SettingsPage } from '@/pages/Settings';
import { useAuthStore } from '@/stores/authStore';
import { ROUTES } from '@/constants/routes';

export const Route = createFileRoute('/_admin/settings')({
  beforeLoad: () => {
    // Admin-only: non-admins get redirected to the dashboard. The parent
    // `_admin` route already enforces authentication.
    if (typeof window === 'undefined') return;
    const user = useAuthStore.getState().user;
    if (user?.userRole !== 'admin') {
      throw redirect({ to: ROUTES.DASHBOARD });
    }
  },
  component: SettingsPage,
});
